import { createFetcher } from '@/services/createFetcher';
import type { NetworkShow } from '@/types';
import type { CampaignsByCategory } from '@/types/api/campaigns';
import type { PayoutDataV2, PayoutEarnings, Payouts } from '@/types/api/payouts';

interface PayoutsFetcherParams {
  networkId: string | undefined;
  year: string | undefined;
  month: string | undefined;
}

/**
 * API fetchers for payouts API.
 * @param networkId - The network ID.
 * @param year - The year.
 * @param month - The month.
 * @returns The fetcher.
 */
export const payoutsFetcher = ({ networkId, year }: Omit<PayoutsFetcherParams, 'month'>) => {
  return createFetcher<Payouts>(`/networks/${networkId}/payouts/${year}`);
};

export const payoutDatesV2Fetcher = ({
  networkId,
}: Omit<PayoutsFetcherParams, 'year' | 'month'>) => {
  return createFetcher<PayoutDataV2>(`/networks/${networkId}/payouts/v2`);
};

export const payoutCampaignsFetcher = ({ networkId, year, month }: PayoutsFetcherParams) => {
  return createFetcher<CampaignsByCategory>(
    `/networks/${networkId}/payouts/${year}/${month}/campaigns`
  );
};

export const payoutEarningsFetcher = ({ networkId, year, month }: PayoutsFetcherParams) => {
  return createFetcher<PayoutEarnings>(`/networks/${networkId}/payouts/${year}/${month}/earnings`);
};

export const payoutShowsFetcher = ({ networkId, year, month }: PayoutsFetcherParams) => {
  return createFetcher<NetworkShow[]>(`/networks/${networkId}/payouts/${year}/${month}/shows`);
};